import React from 'react'
import {sanitizeHtml} from 'src/common/helpers/sanitizeHtml'
import type {CategoryData} from '../data/types'

interface HeadToHeadProps {
  data: CategoryData
}

const HeadToHead: React.FC<HeadToHeadProps> = ({data}) => {
  const h = data.headToHead

  const colorOf = (name: string) => {
    const t = data.distribution?.tools.find((x) => x.name === name)
    return t ? t.color : 'var(--moss-neon)'
  }

  return (
    <section className="section light">
      <div className="wrap">
        <div className="subsection">
          <div className="sub-eyebrow">Head-to-head</div>
          <h3>{h.title}.</h3>
          <p className="sub-intro">The two leading vendors in {data.label} face-to-face.</p>
          <div className="h2h-versus">
            <div className="h2h-vcard">
              <div className="vendor-name">
                <span className="dot" style={{background: colorOf(h.a.name)}} />
                {h.a.name}
              </div>
              <div className="stat-block">
                <div className="label">Market adoption</div>
                <div className="val">{h.a.companies}</div>
              </div>
              {h.a.spendShare && (
                <div className="stat-block">
                  <div className="label">Spend share</div>
                  <div className="val">{h.a.spendShare}</div>
                </div>
              )}
              <div className="stat-block">
                <div className="label">{h.a.spendLabel}</div>
                <div className="val neon">{h.a.spend}</div>
              </div>
            </div>
            <div className="h2h-vs">vs</div>
            <div className="h2h-vcard">
              <div className="vendor-name">
                <span className="dot" style={{background: colorOf(h.b.name)}} />
                {h.b.name}
              </div>
              <div className="stat-block">
                <div className="label">Market adoption</div>
                <div className="val">{h.b.companies}</div>
              </div>
              {h.b.spendShare && (
                <div className="stat-block">
                  <div className="label">Spend share</div>
                  <div className="val">{h.b.spendShare}</div>
                </div>
              )}
              <div className="stat-block">
                <div className="label">{h.b.spendLabel}</div>
                <div className="val neon">{h.b.spend}</div>
              </div>
            </div>
          </div>
          <div className="h2h-flowcard">
            <div className="head">Of companies that tried both</div>
            {h.flow.map((f, i) => (
              <div key={i} className={`row ${f.type}`}>
                <div className="left-text" dangerouslySetInnerHTML={{__html: sanitizeHtml(f.text)}} />
                <div className="bar">
                  <span style={{width: `${f.pct}%`}} />
                </div>
                <div className="pct">{f.pct}%</div>
              </div>
            ))}
          </div>
          {h.footer && <div className="cat-insight" dangerouslySetInnerHTML={{__html: sanitizeHtml(h.footer)}} />}
        </div>
      </div>
    </section>
  )
}

export default HeadToHead
